// Knowledge detail full route. Edit happens in-place via EditKnowledgeModal
// inside KnowledgeDetailPage — no `/edit` child route exists, so this file
// renders the page directly (no <Outlet />).
import { createFileRoute, useParams } from "@tanstack/react-router";
import KnowledgeDetailPage from "@/features/knowledges/KnowledgeDetailPage";

export const Route = createFileRoute("/_admin/knowledges/$knowledgeId")({
  staticData: {
    breadcrumb: { label: "Knowledge detail" },
  },
  component: KnowledgeDetailRoute,
});

function KnowledgeDetailRoute() {
  const { knowledgeId } = useParams({ strict: false }) as { knowledgeId: string };
  return <KnowledgeDetailPage knowledgeId={knowledgeId} />;
}
